<template>
  <div class="SaleOrderDetailViewContainer">
    <span><span class="lightText">单号：</span>{{ order.orderId }}</span>
    <nut-row class="leftCenter mt12 wd100">
      <span class="lightText">买家：</span>
      <img :src="order.buyerAvatar" class="sqr30 brd30">
      <span class="ml6">{{ order.buyerName }}</span>
    </nut-row>
    <nut-row class="leftCenter wd100 mt12">
      <span class="lightText">代理：</span>
      <img :src="order.agentAvatar" class="sqr30 brd30">
      <span class="ml6">{{ order.agentName }}</span>
    </nut-row>
    <nut-row class="bothCenter mt8">
      <nut-col :span="4" class="leftCenter">
        <img :src="order.goodImage"
             class="sqr40 brd8"/>
      </nut-col>
      <nut-col :span="20" class="colFlex">
        <nut-ellipsis class="boldFont ft14" :rows="1" v-if="order.goodName" :content="order.goodName"/>
        <nut-ellipsis class="boldFont ft14" :rows="1" v-if="order.skuName" :content="order.skuName"/>
      </nut-col>
    </nut-row>
    <span class="mt12 "><span class="lightText">实付金额：</span>¥{{ (order.amt / 100).toFixed(2) }}</span>
    <span><span class="lightText">下单时间：</span>{{ order.createdTime }}</span>
    <span><span class="lightText">支付时间：</span>{{ order.paidTime }}</span>
    <span class="numberText" v-if="order?.orderState == 'ProfitShared'">{{
        `分账金额：¥${(order.agentCommission / 100.0).toFixed(2)}`
      }}</span>
    <span class="numberText" v-if="order.refundAmt">{{ `退款金额：¥${(order.refundAmt / 100.0).toFixed(2)}` }}</span>
    <span class="numberText" v-if="order.refundTime">退款时间：{{ order.refundTime }}</span>

    <template v-if="permissions.includes('MOBILE_ORDER_DETAIL')">
      <span class="mt12"></span>
      <span v-if="order.contactName"><span class="lightText">联系人：</span>{{ order.contactName }}</span>
      <span v-if="order.contactPhone"><span class="lightText">手机号：</span>{{ order.contactPhone }}</span>
      <span v-if="order.contactAddress"><span class="lightText">地址：</span>{{ order.contactAddress }}</span>
      <span v-if="order.expressNo"><span class="lightText">物流单号：</span>{{ order.expressNo }}</span>
      <span class="mt12"></span>
      <span v-if="order.xuepaiCourseName"><span class="lightText">已开学拍普通课：</span>{{
          order.xuepaiCourseName
        }}</span>
      <span v-if="order.xuepaiPlanName"><span class="lightText">已开学拍打卡课：</span>{{ order.xuepaiPlanName }}</span>
      <template v-if="order.extraPaidInfos">
      <span v-for="(e,ei) in Object.keys(order.extraPaidInfos)"
            :key="`ei_${ei}`"><span class="lightText">{{ e }}：</span>{{ order.extraPaidInfos[e] }}</span>
      </template>

      <nut-row class="bothCenter mt12" v-if="order?.orderState == 'PAID'">
        <nut-button type="warning" class="wd100 mt16" @click="shareProfit">分账</nut-button>
      </nut-row>
      <nut-row class="bothCenter mt12" v-if="order?.orderState == 'ProfitShared'">
        <nut-button type="warning" class="wd100 mt16" @click="shareProfitRollback">撤回分账</nut-button>
      </nut-row>

      <nut-row class="mt16"
               v-if="(order.refundAmt == null || order.refundAmt < order.amt)
               && order?.orderState == 'PAID'
               && permissions.includes('MOBILE_REFUND')">
        <template v-if="refundVisible">
          <nut-input placeholder="请输入" label="退款原因" v-model="refund.reason"></nut-input>
          <nut-input placeholder="请输入" label="退款金额(元)" type="number" v-model="refund.refundAmt"></nut-input>
        </template>
        <nut-button type="danger" class="wd100 mt16" v-if="!refundVisible" @click="refundVisible=true">退款</nut-button>
        <nut-row class="bothCenter mt16" v-if="refundVisible">
          <nut-col :span="12" class="bothCenter">
            <nut-button type="danger" style="width: 80%" class="wd100 mt16" @click="confirmRefund">确认</nut-button>
          </nut-col>
          <nut-col :span="12" class="bothCenter">
            <nut-button class="wd100 mt16" style="width: 80%" @click="refundVisible=false">取消</nut-button>
          </nut-col>
        </nut-row>
      </nut-row>
      <nut-row class="mt16"
               v-if="order?.orderState == 'REFUND_CONFIRMING'
               && permissions.includes('MOBILE_REFUND_AUDIT')">
        <span style="color: #3D92FD">退款审核:</span>
        <nut-input placeholder="可选填同意/不同意原因" label="备注" v-model="audit.remark"></nut-input>
        <nut-row class="bothCenter mt16">
          <nut-col :span="12" class="bothCenter">
            <nut-button type="danger" style="width: 80%" class="wd100 mt16" @click="passRefund">同意退款</nut-button>
          </nut-col>
          <nut-col :span="12" class="bothCenter">
            <nut-button class="wd100 mt16" style="width: 80%" @click="rejectRefund">拒绝退款</nut-button>
          </nut-col>
        </nut-row>
      </nut-row>
    </template>

    <template v-if="refunds.length > 0">
      <span class="boldFont mt12">退款申请历史</span>
      <div v-for="(r,ri) in refunds" :key="`refund_${ri}`">
        <div class="refundHistory  pd12 box brd6 ft12 colFlex mt12">
          <span style="color: red">申请序号：{{ri+1}}</span>
          <span>申请时间：{{r.createdTime}}</span>
          <span>申请人：{{r.creatorName}}</span>
          <span>申请理由：{{r.reason}}</span>
          <span>退款金额：{{(r.refundAmt/100.0).toFixed(2)}}</span>
          <span >审批状态：{{refundAuditStates[r.state]}}</span>
          <span v-if="r.auditorName">审批人：{{r.auditorName}}</span>
          <span v-if="r.updatedTime">审批时间：{{r.updatedTime}}</span>
          <span v-if="r.remark">审批回复：{{r.remark}}</span>
          <span v-if="r.optMessage">退款结果：{{r.optMessage}}</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import api from "@/api";
import {Dialog, Toast} from "@nutui/nutui";

export default {
  name: "SaleOrderDetailView",
  components: {},
  data() {
    return {
      orderId: this.$route.params.orderId,
      order: {},
      sku: {},
      good: {},
      permissions: [],
      refundVisible: false,
      refund: {
        reason: null,
        refundAmt: null,
      },
      audit: {
        id: this.$route.params.orderId,
        remark: null,
      },
      refunds:[],
      refundAuditStates:{
        'INIT':'待审批',
        'PASS':'已同意',
        'REJECT':'已拒绝',
      }
    }
  },
  methods: {
    passRefund() {
      this.audit.result = true;
      Toast.loading('请稍等...')
      api.auditRefund(this.audit)
          .then(() => {
            this.init()
          }).finally(() => {
        Toast.hide()
      })
    },
    rejectRefund() {
      this.audit.result = false;
      api.auditRefund(this.audit)
          .then(() => {
            this.init()
          })
    },
    shareProfit() {
      Dialog({
        title: '确认分账吗',
        content: `分账金额为¥${(this.order.agentCommission / 100.0).toFixed(2)}`,
        cancelText: '我再考虑考虑',
        okText: '马上分账',
        onCancel: () => {

        },
        onOk: () => {
          this.confirmShareProfit()
        }
      });
    },
    shareProfitRollback() {
      Dialog({
        title: '确认撤销分账吗',
        content: '该操作可能不会成功',
        cancelText: '我再考虑考虑',
        okText: '确认',
        onCancel: () => {

        },
        onOk: () => {
          this.confirmShareProfitRollback()
        }
      });
    },
    init() {
      api.getAgentSaleOrder({
        orderId: this.orderId,
      }).then(ret => {
        this.order = ret.order;
        this.sku = ret.sku;
        this.good = ret.good;
        this.permissions = ret.permissions;
        if(ret.permissions?.includes('MOBILE_REFUND')){
          this.loadRefundHistory();
        }
      })
    },
    loadRefundHistory(){
      api.getRefundHistory(this.orderId)
          .then(ret => {
            this.refunds = ret;
          })
    },
    confirmRefund() {
      this.refund.orderId = this.orderId;
      Toast.loading('请稍等')
      api.refundSaleOrder(this.refund)
          .then(() => {
            Toast.hide()
            Toast.success('已提交');
            this.refundVisible = false;
            this.init()
          })
    },
    confirmShareProfitRollback() {
      Toast.loading('请稍等...')
      api.confirmShareProfitRollback({
        orderId: this.orderId,
      }).then(() => {
        Toast.success('提交成功')
        this.init()
      })
    },
    confirmShareProfit() {
      Toast.loading('请稍等...')
      api.confirmShareProfit({
        orderId: this.orderId,
      }).then(() => {
        Toast.success('提交成功')
        this.init()
      })
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.SaleOrderDetailViewContainer {
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 16px;

  .refundHistory{
    box-shadow: 0px 4px 16px 0px rgba(0,0,0,0.2);
  }
}
</style>